export class ListAwsExternalRecoveryPointsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "start",
            "baseName": "start",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "end",
            "baseName": "end",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return ListAwsExternalRecoveryPointsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
